import { TFunction } from 'i18next';

export enum FREQUENCY_TYPE {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export enum FREQUENCY_DETAIL {
  EVERYDAY = 'everyday',
  WEEKDAYS = 'weekdays',
}

export const getFrequencyOptions = (t: TFunction) => {
  return [
    {
      value: FREQUENCY_TYPE.DAILY,
      label: t('Daily'),
    },
    {
      value: FREQUENCY_TYPE.WEEKLY,
      label: t('Weekly'),
    },
    {
      value: FREQUENCY_TYPE.MONTHLY,
      label: t('Monthly'),
    },
  ];
};
